import { useParams, Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import Seo from "@/components/Seo";
import { Reveal } from "@/components/Reveal";
import { getExperiment } from "@/data/playground";
import FlowField from "@/components/playground/FlowField";
import Game2048 from "@/components/playground/Game2048";

// Map experiment slugs to their interactive components.
const COMPONENTS = {
  "flow-field": FlowField,
  "2048": Game2048,
};

export default function PlaygroundDetail() {
  const { slug } = useParams();
  const exp = getExperiment(slug);
  const Component = COMPONENTS[slug];

  if (!exp || !Component) {
    return (
      <div className="pt-44 pb-32 text-center px-6" data-testid="playground-error">
        <p className="text-ash">Experiment not found.</p>
        <Link to="/playground" className="mt-4 inline-block text-cream underline">
          Back to playground
        </Link>
      </div>
    );
  }

  return (
    <div data-testid="playground-detail" className="pt-32 lg:pt-40 pb-24 lg:pb-32">
      <Seo
        title={`${exp.title} — Playground`}
        description={exp.blurb}
        path={`/playground/${exp.slug}`}
        type="article"
      />
      <div className="mx-auto max-w-5xl px-6 lg:px-10">
        <Link
          to="/playground"
          data-testid="back-to-playground"
          className="group inline-flex items-center gap-2 text-ash hover:text-cream transition-colors mb-12"
        >
          <ArrowLeft size={16} className="transition-transform group-hover:-translate-x-1" />
          All experiments
        </Link>

        <Reveal>
          <span className="rounded-full border border-white/15 px-3 py-1 text-xs text-cream/80">
            {exp.kind}
          </span>
          <h1 className="mt-6 font-heading font-light text-4xl sm:text-5xl tracking-tight text-cream text-balance">
            {exp.title}
          </h1>
          <p className="mt-5 max-w-2xl text-ash text-lg leading-relaxed">{exp.blurb}</p>
        </Reveal>

        <Reveal delay={0.1}>
          <div className="mt-12">
            <Component />
          </div>
        </Reveal>
      </div>
    </div>
  );
}
